import React from 'react';
import { X } from 'lucide-react';
import { getChipConfig, getSourceConfig } from './chipConfig';

// Renders a "Filtering: [Pill ✕] × [Pill ✕]" breadcrumb row above the
// results, only when at least one chip filter is non-default. Each pill
// removes its own dimension on click.
export default function ActiveFilterBreadcrumb({
  statusFilter, setStatusFilter,
  sourceFilter, setSourceFilter,
}) {
  if (statusFilter === 'ALL' && sourceFilter === 'ALL') return null;

  return (
    <div className="flex flex-wrap items-center gap-2 mb-4 text-sm" data-testid="active-filters">
      <span className="text-muted-foreground font-semibold">Filtering:</span>

      {statusFilter !== 'ALL' && (
        <Pill
          label={getChipConfig(statusFilter).label}
          inactiveBg={getChipConfig(statusFilter).inactiveBg}
          onRemove={() => setStatusFilter('ALL')}
          testId="active-filter-status"
        />
      )}

      {statusFilter !== 'ALL' && sourceFilter !== 'ALL' && (
        <span className="text-muted-foreground text-xs" aria-hidden="true">×</span>
      )}

      {sourceFilter !== 'ALL' && (
        <Pill
          label={getSourceConfig(sourceFilter).label}
          inactiveBg={getSourceConfig(sourceFilter).inactiveBg}
          onRemove={() => setSourceFilter('ALL')}
          testId="active-filter-source"
        />
      )}
    </div>
  );
}

function Pill({ label, inactiveBg, onRemove, testId }) {
  return (
    <button
      type="button"
      onClick={onRemove}
      data-testid={testId}
      aria-label={`Remove ${label} filter`}
      title="Click to remove this filter"
      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full border text-xs font-semibold ${inactiveBg} hover:opacity-80 transition-opacity`}
    >
      <span>{label}</span>
      <X className="w-3 h-3" />
    </button>
  );
}
